export default __webpack_public_path__ + "static/media/hamzaJaved.bfbb50ce.jpg";